
export const environment = {
  production: true,
  smartPerformanceApiServer: "https://minalba.legacy.smartperformancedev.online/api",
  smartPerformanceApiLocal: 'https://minalba.legacy.smartperformancedev.online/api',//"https://minalba.legacy.smartperformancedev.online/api",
  accessToken: "m0G7WB4ZzXqgM1Twq5MzKcc6aLzN6sBi81eLwFxSQgbARqOb3Ulceh2dhXQWpSXqXD",
  apiUrl: "https://minalba.legacy.smartperformancedev.online/api"
};
